import { LetterTemplateModel } from "@/api/LetterTemplates/models";
import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type UploadLetterTemplatesRequest = {
  file: File;
};

export type UploadLetterTemplatesResponse = {
  letterTemplate: LetterTemplateModel;
};

export const uploadLetterTemplate = async (request: UploadLetterTemplatesRequest) => {
  const formData = new FormData();
  formData.append("file", request.file);

  const response = await executeApiRequest(() => axios.post<UploadLetterTemplatesResponse>("/lettertemplates", formData), false);

  return response?.data.letterTemplate;
};
